<div class="stepper-container">
  <div
    *ngFor="let step of stepArray; let i = index"
    class="step"
    [ngClass]="{ 'selected': i === currentStep, 'unselected': i !== currentStep }"
  ></div>
</div>